/* eslint-disable import/no-anonymous-default-export */
import {
  GET_ALL_PROVINCIAS,
  GET_ALL_SERVICIOS,
  GET_ALL_SUCURSALES,
  GET_ALL_TIPOS_CONVENIOS,
  GET_ALL_CONVENIOS,
  GET_ALL_CANTONES,
  GET_ALL_DISTRITOS,
  // COMPLETE_SUCURSALES,
  GET_BIENES_SEARCH,
  GET_TIPOS_BIEN,
  GET_ALL_CONVENIOS_TILES,
} from "../actions/types";
const initialState = [];

const baseReducer = function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_PROVINCIAS:
      return {
        ...state,
        provincias: payload,
      };
    case GET_ALL_SERVICIOS:
      return {
        ...state,
        servicios: payload,
      };
    case GET_ALL_SUCURSALES:
      return {
        ...state,
        sucursales: payload,
      };
    case GET_ALL_TIPOS_CONVENIOS:
      return {
        ...state,
        tiposConvenios: payload,
      };
    case GET_ALL_CONVENIOS:
      return {
        ...state,
        convenios: payload,
      };
    case GET_ALL_CANTONES:
      return {
        ...state,
        cantones: payload.Items,
      };
    case GET_ALL_DISTRITOS:
      return {
        ...state,
        distritos: payload.items,
      };
    case GET_BIENES_SEARCH:
      return {
        ...state,
        bienes: payload,
      };
    case GET_TIPOS_BIEN:
      return {
        ...state,
        tiposBien: payload,
      };
    case GET_ALL_CONVENIOS_TILES:
      return {
        ...state,
        conveniosTiles: payload,
      };
    default:
      return state;
  }
};

export default baseReducer;
